/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleDictionaryVm
 */
export interface SimpleDictionaryVm {
    /**
     * 
     * @type {string}
     * @memberof SimpleDictionaryVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleDictionaryVm
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleDictionaryVm
     */
    value?: string | null;
}

export function SimpleDictionaryVmFromJSON(json: any): SimpleDictionaryVm {
    return SimpleDictionaryVmFromJSONTyped(json, false);
}

export function SimpleDictionaryVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleDictionaryVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SimpleDictionaryVmToJSON(value?: SimpleDictionaryVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
    };
}


